import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import type { UserInfo } from '@/features/register/context/register.context';

import { useInterviewContext } from '@/features/common/contexts/interview.context';
import FormScreen, { type FormStepNextPayload } from '@/features/register/pages/FormScreen';

import { useRegisterContext } from '../../contexts/register-context.ref';

export default function RegisterPhonePage() {
  const navigate = useNavigate();
  const { onReset } = useInterviewContext();
  const { registerInitialData, formError, handleRegisterPhoneNext, isRegistering } =
    useRegisterContext();

  const handleBack = useCallback(() => {
    navigate('/register/city', { replace: true });
  }, [navigate]);

  const handleNext = useCallback(
    async (data?: FormStepNextPayload) => {
      // On phone step, children only ever pass full UserInfo
      if (data) await handleRegisterPhoneNext(data as UserInfo);
    },
    [handleRegisterPhoneNext],
  );

  return (
    <FormScreen
      step="phone"
      onNext={handleNext}
      onCancel={onReset}
      onBack={handleBack}
      initialData={registerInitialData}
      error={formError}
      isLoading={isRegistering}
    />
  );
}
